// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"water_wrapper__2ZBcY"};